import { render, staticRenderFns } from "./FaqBoxV2.vue?vue&type=template&id=41e4eb0f&"
import script from "./FaqBoxV2.js?vue&type=script&lang=js&"
export * from "./FaqBoxV2.js?vue&type=script&lang=js&"
import style0 from "./FaqBoxV2.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports